module.exports = __webpack_public_path__ + "static/media/espressosiciliastyle.6988f578.jpg";